export const clientAddressConstant = {
    CREATE_CLIENT_ADDRESS_REQUEST : "CREATE_CLIENT_ADDRESS_REQUEST",
    CREATE_CLIENT_ADDRESS_SUCCESS : "CREATE_CLIENT_ADDRESS_SUCCESS",
    CREATE_CLIENT_ADDRESS_FAILURE : "CREATE_CLIENT_ADDRESS_FAILURE",
}